import ConnectionRequests from '../../components/consultants/ConnectionRequests'
import InviteForm from '../../components/consultants/inviteForm'
import { createApp } from 'vue';

if(document.getElementById('connections-page')){
    const app = createApp({
        components: {
          ConnectionRequests,
          InviteForm
        },
    });
    app.mount('#connections-page');
}
